import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./Reducers/authSlice";
import globalReducer from "./Reducers/globalSlice"
import songReducer from "./Reducers/songSlice"
import eventReducer from "./Reducers/eventSlice"
import notificationReducer from "./Reducers/notificationSlice"

export const store = configureStore({
  reducer: {
    globalSlice: globalReducer,
    userAuth: userReducer,
    songAuth: songReducer,
    eventAuth: eventReducer,
    notification: notificationReducer
  },
});
